import styles from './StackedPapers.module.scss';

export interface StackedPapersProps {
  children: JSX.Element;
}

function StackedPapers({children}: StackedPapersProps): JSX.Element {
  return (
    <aside className={styles.wrapper} data-testid="stackedPapers">
      <span className={styles.backPage} aria-hidden />
      <article className={styles.topPage}>{children}</article>
    </aside>
  );
}

export default StackedPapers;
